import LTR from "@brand-icons/ploom/hand-coins/hand-coins-ltr.svg";
import RTL from "@brand-icons/ploom/hand-coins/hand-coins-rtl.svg";

import { iconFactory } from "../iconFactory";

export const HandCoinsIcon = iconFactory("HandCoinsIcon", LTR, RTL);
